// eslint-disable-next-line
import { HomePageLayout, MainPageLayout } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/Home',
    component: HomePageLayout,
    redirect: '/Home/Index',
    hidden: true,
    children: [
      {
        path: '/Home/Index',
        name: 'Index',
        component: () => import('@/views/Home/Index'),
      },
    ],
  },
  {
    path: '/Main',
    component: MainPageLayout,
    redirect: '/ProjectView',
    hidden: true,
    children: [
      // {
      //   path: '/Project/:type',
      //   name: 'Project',
      //   component: () => import('@/views/Project/Project'),
      // },
      //项目首页
      {
        path: '/ProjectView',
        name: 'ProjectView',
        component: () => import('@/views/ProjectView/ProjectView'),
      },
      // {
      //   path: '/Template',
      //   name: 'Template',

      //   component: () => import('@/views/Project/Template'),
      // },
      //项目菜单
      {
        path: '/ProjectInfo',
        name: 'ProjectInfo',
        redirect: '/ProjectInfo/ProjectAll',
        component: () => import('@/views/Project/ProjectInfo'),
        children: [
          //工作台
          {
            path: '/ProjectInfo/ProjectAll',
            name: 'ProjectAll',
            component: () => import('@/views/Project/ProjectInfo/ProjectAll'),
          },

          // //项目资料清单
          // {
          //   path: '/ProjectInfo/ScheduleDocument',
          //   name: 'ScheduleDocument',
          //   component: () =>
          //     import('@/views/Project/Page/ProjectAudit/ScheduleDocument.vue'),
          // },
          // //配件清单
          // {
          //   path: '/ProjectInfo/Spare',
          //   name: 'Spare',
          //   component: () =>
          //     import('@/views/Project/Page/ProjectAudit/Spare.vue'),
          // },
          // 项目统计
          // {
          //   path: '/ProjectInfo/ProjectStatistic',
          //   name: 'Spare',
          //   component: () =>
          //     import('@/views/Project/Page/ProjectAudit/ProjectStatistic.vue'),
          // },

          // // 设备统计
          // {
          //   path: '/ProjectInfo/DeviceStatistic',
          //   name: 'Spare',
          //   component: () =>
          //     import('@/views/Project/Page/ProjectAudit/DeviceStatistic.vue'),
          // },
          // // 供应商统计
          // {
          //   path: '/ProjectInfo/SupplierStatistic',
          //   name: 'SupplierStatistic',
          //   component: () =>
          //     import('@/views/Project/Page/ProjectAudit/SupplierStatistic.vue'),
          // },

          //设备审核
          {
            path: '/ProjectInfo/ProjectDeviceAudit',
            name: 'ProjectDeviceAudit',
            component: () =>
              import('@/views/Project/ProjectInfo/ProjectDeviceAudit.vue'),
          },
          //供应商资质审核
          {
            path: '/ProjectInfo/TeamAuditDocument',
            name: 'TeamAuditDocument',
            component: () =>
              import('@/views/Project/Page/ProjectAudit/TeamAuditDocument.vue'),
          },
          //项目资料审核
          {
            path: '/ProjectInfo/ProjectDocument',
            name: 'ProjectDocument',
            component: () =>
              import('@/views/Project/Page/ProjectAudit/ProjectDocument.vue'),
          },
          //通用配件审核
          {
            path: '/ProjectInfo/SparesReview',
            name: 'SparesReview',
            component: () =>
              import('@/views/Project/Page/ProjectAudit/SparesReview.vue'),
          },
          //供应商统计
          {
            path: '/ProjectInfo/SupplierStatistics',
            name: 'SupplierStatistics',
            component: () =>
              import(
                '@/views/Project/Page/ProjectAudit/SupplierStatistics.vue'
              ),
          },
        ],
      },
      //项目信息
      {
        path: '/ProjectInfo/Info',
        name: 'Info',
        component: () => import('@/views/Project/Page/Info'),
      },
      {
        path: '/ProjectInfo/ProjectClass',
        name: 'ProjectClass',
        component: () => import('@/views/Project/Page/ProjectClass'),
      },
      //项目设备
      {
        path: '/ProjectInfo/Facility',
        name: 'Facility',
        component: () => import('@/views/Project/Page/Facility'),
      },
      //项目供应商
      {
        path: '/ProjectInfo/TempSupplier',
        name: 'TempSupplier',
        component: () =>
          import('@/views/Project/Page/TempSupplier/TempSupplier.vue'),
      },
      //项目文件
      {
        path: '/ProjectInfo/File',
        name: 'File',
        component: () => import('@/views/Project/Page/File.vue'),
      },
      //项目统计总览
      {
        path: '/ProjectInfo/ProjectOverview',
        name: 'Spare',
        component: () =>
          import('@/views/Project/ProjectOverview/ProjectOverview.vue'),
      },
      // BIM模型
      {
        path: '/ProjectInfo/BimModel',
        name: 'BimModel',
        component: () => import('@/views/Project/Page/BimModel.vue'),
      },
      //项目完结
      {
        path: '/ProjectInfo/ProjectInspect',
        name: 'ProjectInspect',
        component: () =>
          import('@/views/Project/ProjectInfoHandOver/ProjectInspect.vue'),
      },

      //项目移交
      {
        path: '/ProjectInfo/ProjectInfoHandOver',
        name: 'ProjectInfoHandOver',
        component: () =>
          import('@/views/Project/ProjectInfoHandOver/ProjectInfoHandOver.vue'),
      },
      // {
      //   path: '/ProjectInfo/Schedule',
      //   name: 'Schedule',
      //   component: () =>
      //     import('@/views/Project/Page/ProjectAudit/Schedule.vue'),
      // },
      // {
      //   path: '/ProjectInfo/TeamAuditDocument',
      //   name: 'TeamAuditDocument',
      //   component: () =>
      //     import('@/views/Project/Page/ProjectAudit/TeamAuditDocument.vue'),
      // },
      // {
      //   path: '/ProjectInfo/ProjectDocument',
      //   name: 'ProjectDocument',
      //   component: () =>
      //     import('@/views/Project/Page/ProjectAudit/ProjectDocument.vue'),
      // },
      // {
      //   path: "/ElevatorGO",
      //   name: "ElevatorGO",
      //   component: () => import("@/views/Project/ElevatorGO/ElevatorGO"),
      // },
      // {
      //   path: "/Tools",
      //   name: "Tools",
      //   component: () => import("@/views/Tools/Tools"),
      // },
      // {
      //   path: "/ElevatorGO",
      //   name: "ElevatorGO",
      //   component: () => import("@/views/Tools/ToolsPage/ElevatorGO"),
      // },
      // {
      //   path: "/Mail",
      //   name: "Mail",
      //   component: () => import("@/views/Mail/MailTable"),
      // },
      {
        path: '/Supplier',
        name: 'Supplier',
        component: () => import('@/views/Supplier/Supplier'),
      },
      {
        path: '/PMC',
        name: 'PMC',
        component: () => import('@/views/PMC/PMC'),
      },
      {
        path: '/My',
        name: 'My',
        component: () => import('@/views/My/My'),
      },

      // {
      //   path: "/statistics",
      //   name: "statistics",
      //   component: () => import("@/views/statistics/statistics"),
      // },
    ],
  },
  {
    path: '/DesignPattern',
    name: 'DesignPattern',
    component: () => import('@/views/DesignPattern/DesignPattern'),
  },
  {
    path: '/TemplateLogin',
    name: 'TemplateLogin',
    component: () => import('@/views/TemplateHome/TemplateLogin'),
  },

  {
    path: '/TemplateIndex',
    name: 'TemplateIndex',
    // redirect: '/TemplateHomeForm',
    component: () => import('@/views/TemplateHome/TemplateIndex'),
    children: [
      {
        path: '/TemplateHome',
        name: 'TemplateHome',
        component: () => import('@/views/TemplateHome/TemplateHome'),
      },
      {
        path: '/TemplateForm',
        name: 'TemplateForm',
        component: () => import('@/views/TemplateHome/TemplateForm'),
      },
      {
        path: '/TemplateUser',
        name: 'TemplateUser',
        component: () => import('@/views/TemplateHome/TemplateUser'),
      },
    ],
  },
  {
    path: '/UserSign',
    name: 'UserSign',
    component: () => import('@/views/UserH5/UserSign.vue'),
  },
  // {
  //   path: "/XunJianGo",
  //   name: "XunJianGo",
  //   component: () => import("@/views/MobileApp/XunJianGo.vue"), //andriond移动端app下载
  // },
  // {
  //   path: "/XunJianGoIOS",
  //   name: "XunJianGoIOS",
  //   component: () => import("@/views/MobileApp/XunJianGoIOS.vue"), //ios移动端app下载
  // },
  // {
  //   path: "/Ding",
  //   name: "Ding",
  //   component: () => import("@/views/LoginFile/Ding"),
  // },
  // {
  //   path: "/Wechat",
  //   name: "Wechat",
  //   component: () => import("@/views/LoginFile/Wechat"),
  // },

  {
    //服务协议
    path: '/Not/Article',
    name: 'NoT',
    component: () => import('@/views/NoT/Article'),
  },
  {
    //隐私政策
    path: '/Not/Privacys',
    name: 'NoT',
    component: () => import('@/views/NoT/Privacys'),
  },
  {
    path: '/404',
    component: () => import('@/views/exception/404'),
  },
  // {
  //   path: '/Not/GoArticle',
  //   name: 'NoT',
  //   component: () => import('@/views/NoT/GoArticle'),
  // },
  // {
  //   path: '/Not/GoPrivacys',
  //   name: 'NoT',
  //   component: () => import('@/views/NoT/GoPrivacys'),
  // },

  // {
  //   path: "/My/BindingWX",
  //   component: () => import("@/views/My/BindingWX"),
  // },
  // {
  //   path: "/ExternalUserLogin",
  //   name: "ExternalUserLogin",
  //   component: () => import("@/views/Project_ExternalUser/ExternalUserLogin"),
  // },

  // {
  //   path: "/ExternalUserInfo",
  //   name: "ExternalUserInfo",
  //   component: () => import("@/views/Project_ExternalUser/ExternalUserInfo"),
  // },
  // {
  //   path: "/Shop_ApprovalInfoList",
  //   name: "Shop_ApprovalInfoList",
  //   meta: {
  //     keepAlive: true,
  //   },
  //   component: () =>
  //     import("@/views/Project_ExternalUser/Shop_ApprovalInfoList"),
  // },
  // {
  //   path: "/Shop_ApprovalInfoDetail",
  //   name: "Shop_ApprovalInfoDetail",
  //   component: () =>
  //     import("@/views/Project_ExternalUser/Shop_ApprovalInfoDetail"),
  // },
  // //外审登录
  // {
  //   path: "/Shop_SubmitApprovalLogin",
  //   name: "Shop_SubmitApprovalLogin",
  //   component: () =>
  //     import("@/views/Project/Shop_Manage/Shop_SubmitApprovalLogin"),
  // },
  // {
  //   path: "/Shop_SubmitApprovalList",
  //   name: "Shop_SubmitApprovalList",
  //   component: () =>
  //     import("@/views/Project/Shop_Manage/Shop_SubmitApprovalList"),
  // },
  // //审核GO登录
  // {
  //   path: "/RG_SubmitApprovalLogin",
  //   name: "RG_SubmitApprovalLogin",
  //   component: () => import("@/views/Project/ReviewGO/RG_SubmitApprovalLogin"),
  // },
  // {
  //   path: "/RG_SubmitApprovalList",
  //   name: "RG_SubmitApprovalList",
  //   component: () => import("@/views/Project/ReviewGO/RG_SubmitApprovalList"),
  // },
  // //审核GOH5登录
  // {
  //   path: "/RG_UserLogin",
  //   name: "RG_UserLogin",
  //   component: () => import("@/views/Project_RG_User/RG_UserLogin"),
  // },
  // {
  //   path: "/RG_UserInfo",
  //   name: "RG_UserInfo",
  //   component: () => import("@/views/Project_RG_User/RG_UserInfo"),
  // },
  // {
  //   path: "/RG_ApprovalInfoList",
  //   name: "RG_ApprovalInfoList",
  //   meta: {
  //     keepAlive: true,
  //   },
  //   component: () => import("@/views/Project_RG_User/RG_ApprovalInfoList"),
  // },
  // {
  //   path: "/RG_ApprovalInfoDetail",
  //   name: "RG_ApprovalInfoDetail",
  //   component: () => import("@/views/Project_RG_User/RG_ApprovalInfoDetail"),
  // },

  // //文件分享页面
  // {
  //   path: "/File_SharingInfo",
  //   name: "File_SharingInfo",
  //   component: () => import("@/views/Project/File_Manage/File_SharingInfo"),
  // },

  // {
  //   path: "/TransferUrl",
  //   name: "TransferUrl",
  //   component: () => import("@/views/TransferUrl/TransferUrl"),
  // },
]
